import React from 'react'
import styled from 'styled-components'

const Error = styled.div`
position: relative;
width:100%;
height:100%;
h1 {
    position: absolute;
    width:100%;
    height:100%;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    color: rgba(255,255,255,0.5);
    font-size: 2em;
    text-align:center;
    opacity:1;
    line-height:2.1em;
}

@keyframes error {
    0% {
        opacity:0;
    }
}
@media screen and (max-width:768px){
    h1{
        font-size:2em;
    }
}
`

export default ({ data }) => {
    return (
        <>
            <Error ><br /><br />
                <h1 data-text={data}>{data}</h1>
            </Error >
        </>
    )
}